import axios from 'axios';
import { API_BASE_URL } from '../api';

export const createInspirationalDesign = async (designData) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
  
  const res = await axios.post(`${API_BASE_URL}/inspirational-designs`, designData, { 
    headers,
    timeout: 30000
  });
  return res.data.data.inspirationalDesign;
};

let listInFlight = null;
let listInFlightKey = '';

export const getInspirationalDesigns = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  if (filters.productName) queryParams.append('productName', filters.productName);
  if (filters.isActive !== undefined) queryParams.append('isActive', filters.isActive);

  const cacheKey = queryParams.toString();
  if (listInFlight && listInFlightKey === cacheKey) {
    return listInFlight;
  }

  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };

  const url = `${API_BASE_URL}/inspirational-designs${cacheKey ? `?${cacheKey}` : ''}`;
  listInFlightKey = cacheKey;
  listInFlight = axios
    .get(url, { headers, timeout: 30000 })
    .then((res) => res.data.data.inspirationalDesigns)
    .finally(() => {
      listInFlight = null;
      listInFlightKey = '';
    });

  return listInFlight;
};

export const getInspirationalDesignById = async (id) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
  
  const res = await axios.get(`${API_BASE_URL}/inspirational-designs/${id}`, { 
    headers,
    timeout: 30000
  });
  return res.data.data.inspirationalDesign;
};

export const updateInspirationalDesign = async (id, designData) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
  
  const res = await axios.put(`${API_BASE_URL}/inspirational-designs/${id}`, designData, { 
    headers,
    timeout: 30000
  });
  return res.data.data.inspirationalDesign;
};

export const deleteInspirationalDesign = async (id) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
  
  await axios.delete(`${API_BASE_URL}/inspirational-designs/${id}`, { 
    headers,
    timeout: 30000
  });
};

/** Public storefront: seller's active inspirational / body-cut images (no auth) */
export const getPublicInspirationalDesignsByPhone = async (phoneNumber, page = 1, limit = 24) => {
  const slug = encodeURIComponent(String(phoneNumber || '').trim().toLowerCase());
  const res = await axios.get(`${API_BASE_URL}/inspirational-designs/public/by-phone/${slug}`, {
    params: { page, limit },
    timeout: 30000
  });
  return res.data?.data || { inspirationalDesigns: [], pagination: {} };
};

export const getInspirationalDesignsByProduct = async () => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
  
  const res = await axios.get(`${API_BASE_URL}/inspirational-designs/grouped/by-product`, { 
    headers,
    timeout: 30000
  });
  return res.data.data.groupedDesigns;
};

